import { useParams } from 'react-router';

import { useGetAdvantagesQuery, useGetMainPageQuery } from '@/api/endpoints/mainPages';
import { FetchDataWrapper } from '@/shared/components';

import { transformDateToCorrectFormat } from '../helpers';

import { MainAdvantagesPageComponent } from './MainAdvantagesPageComponent';

export const MainAdvantagesPage = () => {
  const { id } = useParams();
  const {
    data: pageData,
    isLoading: isPageLoading,
    isError: isPageDataFetchError,
  } = useGetMainPageQuery({ id: Number(id) });
  const {
    data: advantagesData,
    isLoading: areAdvantagesLoading,
    isFetching: areAdvantagesFetching,
    isError: isAdvantagesFetchError,
  } = useGetAdvantagesQuery({ id: Number(id) });

  return (
    <FetchDataWrapper
      isLoading={isPageLoading || areAdvantagesLoading}
      isError={isAdvantagesFetchError || isPageDataFetchError}
    >
      {pageData && advantagesData && (
        <MainAdvantagesPageComponent
          advantagesData={advantagesData}
          areAdvantagesFetching={areAdvantagesFetching}
          pageName={transformDateToCorrectFormat(pageData.created_at)}
          pageId={pageData.id}
        />
      )}
    </FetchDataWrapper>
  );
};
